import React from 'react';
import Navbar from './Navbar';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <Navbar />

      {/* Main Content */}
      <main className="flex justify-center mb-[128px] mt-[72px]">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
